<template>
  <v-container class="pt-0" style="height: 100%; background-color: #ffffff">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="menuRequest"
          :redirect_name="redirect_name"
          :redirect_query="redirect_query"
        />
      </v-col>
    </v-row>

    <!-- ========== ========== Warranty Registration ========== ========== -->
    <v-card
      v-if="warranty_registration"
      elevation="0"
      outlined
      rounded="lg"
      class="mt-2 mx-2"
      style="background-color: #ffffff"
      :style="{
        border: '1px solid ' + site.color,
      }"
    >
      <v-card-title class="py-2 px-2">
        <v-container>
          <v-row>
            <v-col cols="12" class="pa-1">
              <div class="d-flex" style="gap: 14px; z-index: 1">
                <div class="d-flex align-center" style="min-width: 64px">
                  <div
                    class="d-flex align-center justify-center"
                    style="
                      width: 64px;
                      height: 64px;
                      border-radius: 8px;
                      overflow: hidden;
                    "
                    :style="{
                      background: setBackgoundColorImage(),
                    }"
                  >
                    <v-img
                      v-if="
                        warranty_registration.product_image &&
                        warranty_registration.product_image.length > 0
                      "
                      :src="warranty_registration.product_image[0]"
                      style="width: 100%; height: 100%; object-fit: contain"
                      @error="
                        onImageError(warranty_registration, 'product_image', 0)
                      "
                    >
                    </v-img>
                    <v-icon v-else :color="getFontColorBasedOnBg()" size="40"
                      >mdi-package-variant-closed</v-icon
                    >
                  </div>
                </div>
                <div class="d-flex flex-column" style="width: 100%">
                  <div
                    class="d-flex align-center justify-space-between"
                    style="gap: 4px"
                  >
                    <p
                      class="description-label title-card text-start mb-0 pb-0 text-subtitle-1 font-weight-bold"
                      style="max-height: 42px"
                    >
                      {{ warranty_registration.product_name }}
                    </p>
                    <div
                      v-if="warranty_registration.status"
                      class="d-flex justify-end"
                    >
                      <v-chip
                        class="font-weight-bold"
                        :style="{
                          'background-color': chipStatus(
                            warranty_registration.status
                          ).bg,
                          color: chipStatus(warranty_registration.status).font,
                        }"
                        dark
                        small
                      >
                        {{
                          $t(`warrantyStatus.${warranty_registration.status}`)
                        }}
                      </v-chip>
                    </div>
                  </div>
                  <p
                    class="description-label-1 title-card text-start mb-0 pb-0 text-subtitle-2 grey--text text--darken-1 pt-1"
                  >
                    {{ warranty_registration.serial_number }}
                  </p>
                  <div class="d-flex align-center" style="gap: 4px">
                    <div style="color: #757575; font-size: 14px">
                      {{ $t("expiredAt2") }} :
                    </div>
                    <v-icon small color="#757575">mdi-calendar</v-icon>
                    <div style="color: #757575; font-size: 14px">
                      {{ warranty_registration.expired_at | formatDate }}
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>

    <v-row v-if="showForm" class="px-2 mt-4">
      <v-form ref="form" lazy-validation style="width: 100%">
        <v-col cols="12">
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-select
                v-model="dataItem.report_type_id"
                :label="$t('textType')"
                :items="listType"
                item-text="label"
                item-value="value"
                dense
                hide-details
                :rules="normalRules"
                :disabled="warranty_registration_id ? true : false"
                @change="handleChangeReportType"
              ></v-select>
            </v-col>
            <v-col v-if="inputShow.is_use_title" cols="12" sm="6" md="12">
              <v-text-field
                required
                :rules="normalRules"
                dense
                :label="$t('textTitle')"
                v-model="dataItem.title"
              />
            </v-col>
            <v-col v-if="inputShow.is_use_sub_title" cols="12" sm="6" md="12">
              <v-text-field
                dense
                :label="$t('textSubtitle')"
                v-model="dataItem.sub_title"
              />
            </v-col>
            <v-col
              v-if="reportTypeSchema"
              cols="12"
              sm="6"
              md="12"
              class="py-0"
            >
              <div style="font-weight: 600">{{ $t("textForm") }}</div>
              <SurveyAnswerPage
                ref="refSurveyAnswer"
                :isUseIFrame="false"
                :propSchema="reportTypeSchema"
                :propUseButtonSubmit="false"
              />
            </v-col>
            <v-col v-if="inputShow.is_use_detail" cols="12" sm="6" md="12">
              <quillEditor
                :options="quillConfig"
                v-model="dataItem.detail"
                v-bind:style="[
                  errorDetail
                    ? { border: 'solid 1px red' }
                    : { border: '1px solid transparent' },
                ]"
                style="width: 100%"
                @change="errorDetail = false"
              />
              <p
                style="color: red; font-size: 14px"
                class="mt-1"
                v-if="errorDetail"
              >
                {{ $t("required") }}
              </p>
            </v-col>
            <v-col v-if="inputShow.is_use_attachment" cols="12" sm="6" md="12">
              <v-file-input
                ref="inputReportFile"
                v-model="inputReportFile"
                accept="image/*, video/*, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                color="deep-purple accent-4"
                :label="labelSelectFile"
                dense
                hide-details
                multiple
                :disabled="dataItem.report_files.length == 5"
                :placeholder="labelSelectFile"
                @change="selectFile"
              >
              </v-file-input>
              <div class="mt-2">
                {{
                  $t("hintUploadMultiFile", {
                    fileLimit: fileLimit,
                    fileLimitMB: fileLimitMB,
                  })
                }}
              </div>
              <div v-if="errorFileSize" class="mb-1" style="color: #f44336">
                {{
                  $t("errorUploadLimitFileSize", { fileLimitMB: fileLimitMB })
                }}
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="12" class="pt-0">
              <div
                v-for="(item, index) in dataItem.report_files"
                :key="index"
                class="my-2 d-flex pa-2 align-center"
                style="border: 1px solid #9e9e9e; border-radius: 8px"
              >
                <v-icon class="mr-2">mdi-file-check-outline</v-icon>
                <div style="word-break: break-word">
                  {{ item.name }}
                </div>
                <div class="ml-2">
                  {{ item.size | fileSize }}
                </div>
                <v-icon
                  class="mr-0 ml-auto"
                  @click="deleteFile(item)"
                  color="red"
                >
                  mdi-delete
                </v-icon>
              </div>
            </v-col>
            <!-- ========== ========== ========== ========== -->
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-btn
                class="my-2"
                :color="site.color"
                dark
                style="width: 100%"
                @click="saveReportAdmin"
              >
                {{ $t("submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-form>
    </v-row>

    <div v-if="!showForm">
      <v-col class="d-flex justify-center mt-16">
        <v-img
          class="white--text mx-auto mt-10 empty"
          :src="require('@/assets/images/out-of-stock.png')"
          max-width="150px"
        >
        </v-img>
      </v-col>
      <p class="text-center">{{ $t("errDataNotFound") }}</p>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import Axios from "@/config/customer-service";
import { quillEditor } from "vue-quill-editor";
import _ from "lodash";
import SurveyAnswerPage from "../SurveyJS/SurveyAnswerPage.vue";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "../../../config/general-function";
import moment from "moment";

export default {
  inject: ["isAppLoading"],
  emits: ["onClick"],
  components: {
    HeaderTextBg,
    quillEditor,
    SurveyAnswerPage,
  },

  data() {
    return {
      dataItem: {
        id: null,
        title: "",
        sub_title: "",
        detail: "",
        schema_detail: null,
        document_no: "",
        report_type_id: "",
        report_type_name: "",
        created_at: null,
        is_employee_comment: false,
        receiver_permission: null,
        report_files: [],
        report_permission_public: true,
        report_permissions: [],
        report_receivers: [],
      },

      listType: [],
      forCreatedBy: "employee",
      reportTypeSchema: null,
      inputShowDefault: {
        is_use_title: true,
        is_use_sub_title: true,
        is_use_detail: true,
        is_use_attachment: true,
      },
      inputShow: {
        is_use_title: true,
        is_use_sub_title: true,
        is_use_detail: true,
        is_use_attachment: true,
      },

      inputReportFile: null,
      errorFileSize: false,
      fileLimit: 5,
      fileLimitMB: 40,
      errorDetail: false,

      redirect_name: "request-list",
      redirect_query: null,

      warranty_registration_id: null,
      warranty_registration: null,
    };
  },
  async created() {
    this.isAppLoading(true);
    this.warranty_registration_id =
      this.$route.query.warranty_registration_id || null;
    if (this.warranty_registration_id) {
      this.redirect_query = {
        warranty_registration_id: this.warranty_registration_id,
      };
      await this.getWarrantyRegistrationDetail();
    }
    await this.getListType();
    this.isAppLoading(false);
  },
  methods: {
    setBackgoundColorImage() {
      const _color = this.site.color || "#0f4c81";
      const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(120deg, ${lighten}, ${_color})`;
      return _style;
    },
    getFontColorBasedOnBg() {
      const res = getFontColorBasedOnBg(this.site.color, "bw");
      return res;
    },
    onImageError(item, key, index) {
      if ([null, undefined, ""].includes(index)) {
        item[key] = null;
      } else {
        item[key][index] = null;
      }
    },
    chipStatus(param) {
      const color = {
        active: { bg: "#E8F5E9", font: "#4CAF50" },
        pending: { bg: "#FFF3E0", font: "#FF9800" },
        rejected: { bg: "#FFEBEE", font: "#F44336" },
        expired: { bg: "#E8EAF6", font: "#3F51B5" },
      };
      return {
        bg: color[param]?.bg || "#9E9E9E",
        font: color[param]?.font || "#ffffff",
      };
    },
    // ========== ========== ========== ==========

    async getWarrantyRegistrationDetail() {
      try {
        const response = await Axios.get(
          `warranty-registration/getWarrantyRegistrationDetail/${this.warranty_registration_id}`
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data || [];
          this.warranty_registration = data;
        }
      } catch (err) {
        console.log("getWarrantyRegistrationDetail", err);
      }
    },
    async getListType() {
      try {
        const response = await Axios.get(
          `/report-admin/getListReportType?for_created_by=${
            this.forCreatedBy
          }&for_create=true&use_for=${
            this.warranty_registration_id ? "warranty" : "general"
          }&warranty_registration_id=${
            this.warranty_registration_id || ""
          }&warranty_registration_new_request=true`
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data || [];
          this.listType = [...data];
          if (this.listType.length > 0) {
            const model = this.listType.find((x) => x.is_default);
            this.dataItem.report_type_id = (model || this.listType[0]).id;
            this.dataItem.report_type_name = (model || this.listType[0]).name;
            this.handleChangeReportType();
          }
        }
      } catch (err) {
        console.log("getListType", err);
      }
    },

    // ========== ========== ========== ==========
    handleChangeReportType() {
      const model = this.listType.find(
        (x) => x.id == this.dataItem.report_type_id
      );
      let _inputShow = { ...this.inputShowDefault };
      if (!model) {
        this.dataItem.report_type_id = null;
      } else {
        _inputShow = {
          ...model,
        };
      }
      this.inputShow = {
        ..._inputShow,
      };
      this.reportTypeSchema = model?.schema || null;
      if (this.reportTypeSchema) {
        this.errorDetail = false;
      }
    },
    // ========== ========== ========== ==========
    selectFile(event) {
      for (let [index, item] of event.entries()) {
        const detail = {
          id: `${new Date().getTime()}_${index}`,
          name: item.name,
          size: item.size,
          mime_type: item.type,
          file: item,
        };
        if (this.dataItem.report_files.length < this.fileLimit) {
          this.dataItem.report_files.push(detail);
        }
      }
      // ========== ========== ========== ==========
      let totalSize = 0;
      for (let item of this.dataItem.report_files) {
        totalSize += item.size;
      }
      if (totalSize / 1000000 > this.fileLimitMB) {
        this.errorFileSize = true;
      } else {
        this.errorFileSize = false;
      }
      // ========== ========== ========== ==========
      setTimeout(() => {
        this.inputReportFile = null;
        if (this.$refs.inputReportFile) {
          this.$refs.inputReportFile.reset();
        }
      }, 1000);
    },
    deleteFile(param) {
      this.dataItem.report_files = this.dataItem.report_files.filter(
        (x) => x.id != param.id
      );
      // ========== ========== ========== ==========
      let totalSize = 0;
      for (let item of this.dataItem.report_files) {
        totalSize += item.size;
      }
      let sizeRef = 1000000;
      // sizeRef = 1024 * 1024;
      if (totalSize / sizeRef > this.fileLimitMB) {
        this.errorFileSize = true;
      } else {
        this.errorFileSize = false;
      }
      // ========== ========== ========== ==========
    },
    // ========== ========== ========== ==========
    async convertDetailImageBase64(detail) {
      const regex = /src="([^"]*)"/g;
      let match;
      let listImageSrc = [];
      while ((match = regex.exec(detail)) !== null) {
        if (match.length > 1) {
          listImageSrc.push(match[1]);
        }
      }
      const listImageSrcBase64 = listImageSrc
        .filter((x) => x.includes(";base64,"))
        .map((x) => {
          const _detail = {
            old: x,
            new: null,
          };
          return _detail;
        });
      if (listImageSrcBase64.length > 0) {
        for (let item of listImageSrcBase64) {
          const imageFile = await this.convertBase64ToFile(item.old, "image");
          if (imageFile) {
            const imageUrl = await this.uploadImageDefault(imageFile);
            if (imageUrl) {
              detail = detail.replace(item.old, imageUrl);
            }
          }
        }
      }
      return detail;
    },
    convertBase64ToFile(base64, nameImage) {
      return new Promise((resolve) => {
        const fetchBase64 = fetch(base64);
        fetchBase64
          .then((r) => r.blob())
          .then((blobFile) => {
            const image = new File([blobFile], nameImage, {
              type: blobFile.type,
            });
            resolve(image);
          })
          .catch((err) => {
            console.log("convertBase64ToFile", err);
            resolve(null);
          });
      });
    },
    uploadImageDefault(file) {
      if (file) {
        let formData = new FormData();
        formData.append("image", file);
        formData.append("module", "ReportUser");
        return new Promise((resolve, reject) => {
          Axios.post("uploadImageDefault", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                resolve(data.image_url);
              }
            })
            .catch((err) => {
              console.log(err);
              reject(null);
            });
        });
      } else {
        return null;
      }
    },
    showErrorRequired() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    async saveReportAdmin() {
      let validateReportTypeSchema = false;
      if (this.reportTypeSchema) {
        if (this.$refs.refSurveyAnswer) {
          const schema_detail = await this.$refs.refSurveyAnswer.handleSubmit();
          this.dataItem.schema_detail = schema_detail;
          if (!schema_detail) {
            validateReportTypeSchema = true;
          }
        }
      }
      if (
        !this.$refs.form.validate(true) ||
        (!this.reportTypeSchema &&
          this.inputShow.is_use_detail &&
          this.dataItem.detail == "") ||
        this.errorFileSize ||
        validateReportTypeSchema
      ) {
        if (this.dataItem.detail == "") {
          this.errorDetail = true;
        }
        this.showErrorRequired();
        return;
      }
      // ========== ========== ========== ==========
      this.isAppLoading(true);
      this.dataItem.detail = await this.convertDetailImageBase64(
        this.dataItem.detail
      );
      const data = _.cloneDeep(this.dataItem);
      if (data.report_type_id) {
        const model = this.listType.find((x) => x.value == data.report_type_id);
        data.report_type_id = model.value || null;
      }
      if (this.warranty_registration) {
        data.warranty_registration_id = this.warranty_registration.id;
      }
      data.for_created_by = this.forCreatedBy;
      const formData = new FormData();
      for (let key in data) {
        const value = data[key];
        if (value) {
          if (typeof value == "object") {
            if (Array.isArray(value)) {
              if (value.length == 0) {
                formData.append(key, "");
              } else if (
                ["report_permissions", "report_receivers"].includes(key)
              ) {
                const id = value.map((x) => x.id);
                formData.append(key, JSON.stringify(id));
              } else if (key == "report_files") {
                const id = value.filter((x) => !x.file).map((x) => x.id);
                if (id.length > 0) {
                  formData.append("report_files_id", JSON.stringify(id));
                }
                const file = value.filter((x) => x.file).map((x) => x.file);
                if (file.length > 0) {
                  for (let item of file) {
                    formData.append("report_files[]", item);
                  }
                }
              }
            } else {
              formData.append(key, JSON.stringify(value));
            }
          } else {
            formData.append(key, data[key]);
          }
        } else {
          formData.append(key, "");
        }
      }
      try {
        const response = await Axios.post(
          "/report-admin/createReportAdmin",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          this.$swal
            .fire({
              icon: "success",
              title: this.$t("saveSuccess"),
              showConfirmButton: false,
              timer: 2000,
            })
            .then(() => {
              this.$router.push({
                name: this.redirect_name,
                query: this.redirect_query,
              });
            });
        } else {
          this.$swal.fire(
            this.$t("error.title"),
            dataResponse?.message,
            "error"
          );
        }
      } catch (err) {
        this.$swal.fire(
          this.$t("error.title"),
          err?.response?.data?.error,
          "error"
        );
      }
      this.isAppLoading(false);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    normalRules() {
      return [(v) => !!v || this.$t("required")];
    },
    quillConfig() {
      return {
        modules: {
          toolbar: {
            container: [
              // [{ header: [1, 2, 3, 4, 5, 6, false] }],
              // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
              ["bold", "italic", "underline", "strike"], //toggled buttons
              // [{ list: "ordered" }, { list: "bullet" }],
              // [{ align: [] }],
              // [{ script: "sub" }, { script: "super" }], // superscript/subscript
              // ["link", "image"],
            ],
          },
        },
        placeholder: this.$t("pleaseFillDetail"),
      };
    },
    labelSelectFile() {
      return `${this.$t("textSelectFile")} (${this.$t(
        "textImageType"
      )}, ${this.$t("textVideoType")}, PDF, Excel)`;
    },
    showForm() {
      let check = true;
      if (this.warranty_registration_id) {
        if (this.warranty_registration) {
          if (this.listType.length == 0) {
            check = false;
          }
        } else {
          check = false;
        }
      }
      return check;
    },
  },
  watch: {},
  filters: {
    fileSize: function (value) {
      let label = "";
      const size = value / 1000000;
      label = `(${size} MB)`;
      return label;
    },
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YY, HH:mm");
    },
  },
};
</script>

<style scoped>
.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.description-label-1 {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.title-card {
  line-height: 1.3;
}

::v-deep .ql-editor {
  max-height: 640px;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 200px;
}

::v-deep .sd-body {
  padding-left: 4px !important;
  padding-right: 4px !important;
  padding-bottom: 4px !important;
  max-width: 100% !important;
}

::v-deep .sd-page {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

::v-deep .sd-root-modern {
  background: transparent !important;
}
</style>
